module.exports = __webpack_public_path__ + "static/media/WAN HAI.3d141f22.svg";